import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  PickUpParcelCodeDto,
  PickUpParcelCodeModel,
  PickUpParcelCodeResponse,
} from '../types/pick-up-parcel-code'

export const transformPickUpParcelCode = (
  response: PickUpParcelCodeDto,
): PickUpParcelCodeModel => ({
  imageUrl: response.image_url,
  code: response.code,
})

export const transformPickUpParcelCodeResponse = (response: Response<PickUpParcelCodeResponse>) =>
  transformPickUpParcelCode(response.parcel_collection_code)
